export default function () {
  const rentOrderFormColumns = [
    {
      label: '司机名称:',
      remoteMethod: this.getCustomerNames,
      modelType: 'driverIds',
    },
    {
      label: '车辆名称(ID):',
      remoteMethod: this.getCarNames,
      modelType: 'carIds',
    },
    {
      label: '车牌号:',
      remoteMethod: this.getCarLicenseManage,
      modelType: 'platNos',
    }, {
      label: '租赁订单(ID):',
      remoteMethod: this.getRanOrder,
      modelType: 'ids',
    },
  ]
  const rentOrderTableColumns = [
    {
      prop: 'orderId',
      name: '租赁订单ID',
    },
    {
      prop: 'rentPlanName',
      name: '租赁方案名称',
    },
    {
      prop: 'driverName',
      name: '司机名称',
    },
    {
      prop: 'driverId',
      name: '司机ID',
    },
    {
      prop: 'carModelName',
      name: '车型名称',
    },
    {
      prop: 'plantNo',
      name: '车牌号',
    },
  ]
  return {
    rentOrderFormColumns,
    rentOrderTableColumns,
  }
}
